import { Copy01 } from "@untitledui/icons";
import { DialogTrigger, Heading } from "react-aria-components";
import * as Alerts from "@/components/application/alerts/alerts";
import { Dialog, Modal, ModalOverlay } from "@/components/application/modals/modal";
import { Button } from "@/components/base/buttons/button";
import { CloseButton } from "@/components/base/buttons/close-button";
import { success } from "@/providers/ToastProvider";

export const MissingCreatorsModal = ({ creatorIds, onClose }: { creatorIds: string[]; onClose: () => void }) => {
  const copy = async () => {
    try {
      const text = creatorIds.map((id) => id.replace("CID-", "")).join("\n");
      await navigator.clipboard.writeText(text);
      success("Creator ids copied to clipboard");
    } catch (error) {
      console.error("Failed to copy to clipboard:", error);
    }
  };
  return (
    <DialogTrigger isOpen={true} onOpenChange={() => onClose()}>
      <ModalOverlay isDismissable>
        <Modal className="max-w-md">
          <Dialog>
            <div className="relative w-full overflow-hidden rounded-2xl bg-primary shadow-none transition-all sm:w-full">
              <CloseButton onClick={onClose} size="lg" className="absolute top-3 right-3" />
              <div className="flex flex-col gap-4 px-4 pt-5 mr-4 sm:px-6 sm:pt-6">
                <Heading slot="title" className="text-md font-semibold text-primary">
                  List Created Successfully
                </Heading>
              </div>
              <div className="p-6">
                <Alerts.AlertFloating
                  color="warning"
                  onConfirm={copy}
                  confirmLabel={
                    <div className="flex flex-row items-center gap-1">
                      <Copy01 className="w-4 h-4" />
                      Copy Missing Creator Ids
                    </div>
                  }
                  title="Some creators were not added to the list"
                  description="These creators do not exist in our system. This might be because we have not yet imported them, or they may have been formatted incorrectly"
                />
              </div>
              <div className="z-10 flex flex-1 justify-end flex-col-reverse gap-3 p-4 pt-6 sm:flex-row sm:px-6 sm:pt-8 sm:pb-6">
                <Button color="primary" size="lg" type="button" onClick={onClose}>
                  View List
                </Button>
              </div>
            </div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
};
